<template>
  <div class="legal-mentions">
    <h1>Mentions Légales</h1>

    <section>
      <h2>1. Éditeur du site</h2>
      <p>Le présent site, accessible à l'adresse <a href="https://www.query-juriste.com">https://www.query-juriste.com</a> (ci-après le « Site »), est édité par :</p>
      <p><strong>QUERY JURISTE</strong>, société à responsabilité limitée (SARL) au capital social de 100 euros, immatriculée au Registre du commerce et des sociétés de Paris sous le numéro 929 322 261, dont le siège social est situé 37 rue Rousselet, 75007 Paris, France.</p>
      <p>Numéro de TVA intracommunautaire : FR70 929 322 261</p>
      <p>Représentée par son gérant, Monsieur Etienne Le Guay.</p>
    </section>

    <section>
      <h2>2. Contact</h2>
      <p>Par courrier électronique : <a href="mailto:etienneleguay@query-juriste.com">etienneleguay@query-juriste.com</a></p>
      <p>Par téléphone : +33 7 82 17 80 73</p>
      <p>Par courrier postal : Query Juriste, 37 rue Rousselet, 75007 Paris, France</p>
    </section>

    <section>
      <h2>3. Directeur de la publication</h2>
      <p>Le directeur de la publication du Site, au sens de l'article 93-2 de la loi n° 82-652 du 29 juillet 1982 sur la communication audiovisuelle, est Monsieur Etienne Le Guay, en sa qualité de gérant.</p>
      <p>Aucun responsable de la rédaction distinct n'est désigné.</p>
    </section>

    <section>
      <h2>4. Hébergement du site</h2>
      <p>Le Site est hébergé par :</p>
      <p><strong>Microsoft Ireland Operations Limited</strong>, One Microsoft Place, South County Business Park, Leopardstown, Dublin 18, D18 P521, Irlande (service Azure Static Web Apps, régions Union européenne).</p>
    </section>

    <section>
      <h2>5. Stockage des données traitées dans le cadre de l'édition du Site</h2>
      <p>Conformément au 5° du I de l'article 1-1 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, le stockage durable des données traitées dans le cadre de l'édition du service (comptes utilisateurs, dossiers et résultats d'analyse) est assuré par :</p>
      <p><strong>SCALEWAY</strong>, société par actions simplifiée, immatriculée au Registre du commerce et des sociétés de Paris sous le numéro 433 115 904, dont le siège social est situé 8 rue de la Ville l'Évêque, 75008 Paris, France (datacenters situés en France et dans l'Union européenne).</p>
    </section>

    <section>
      <h2>6. Activité et absence de profession réglementée</h2>
      <p>Query Juriste édite un service logiciel d'aide à la recherche et à l'analyse juridiques destiné aux professionnels du droit. Query Juriste n'est pas un avocat, ni un membre d'une profession juridique ou judiciaire réglementée, et n'exerce aucune activité de consultation juridique ou de rédaction d'actes au sens de la loi n° 71-1130 du 31 décembre 1971. Les résultats fournis par le Site ne constituent pas un conseil juridique et ne se substituent pas à l'intervention d'un professionnel du droit.</p>
      <p>L'activité de Query Juriste n'est soumise à aucun régime d'autorisation administrative préalable.</p>
    </section>

    <section>
      <h2>7. Prix</h2>
      <p>Les prix des abonnements aux services sont indiqués sur le Site et dans les devis adressés aux clients, de manière claire et non ambiguë, en euros, hors taxes et toutes taxes comprises. Les conditions financières détaillées figurent aux Conditions générales de vente.</p>
    </section>

    <section>
      <h2>8. Propriété intellectuelle</h2>
      <p>L'ensemble des éléments composant le Site (marques, logos, textes, illustrations, interfaces, bases de données et logiciels) est protégé par le droit de la propriété intellectuelle et demeure la propriété exclusive de Query Juriste ou de ses concédants. Toute reproduction, représentation, adaptation ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.</p>
    </section>

    <section>
      <h2>9. Données personnelles et cookies</h2>
      <p>Le traitement des données à caractère personnel effectué par Query Juriste est décrit dans la <router-link to="/politique-donnees">Politique de protection des données personnelles</router-link>, conformément au règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi n° 78-17 du 6 janvier 1978 modifiée.</p>
      <p>Toute demande relative aux données personnelles peut être adressée à <a href="mailto:etienneleguay@query-juriste.com">etienneleguay@query-juriste.com</a> ou par courrier au siège social.</p>
    </section>

    <section>
      <h2>10. Conditions contractuelles</h2>
      <p>L'utilisation du Site et des services est régie par les Conditions générales d'utilisation et les Conditions générales de vente.</p>
    </section>

    <section>
      <h2>11. Droit de réponse</h2>
      <p>Conformément au III de l'article 1-1 de la loi n° 2004-575 du 21 juin 2004, toute personne nommée ou désignée sur le Site dispose d'un droit de réponse. Toute demande doit être adressée au directeur de la publication, à <a href="mailto:etienneleguay@query-juriste.com">etienneleguay@query-juriste.com</a> ou par courrier au siège social, dans un délai de trois mois à compter de la mise à disposition du public du message concerné.</p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'LegalMentions'
}
</script>

<style scoped>
.legal-mentions {
  font-family: 'Arial', sans-serif;
  color: black;
  background-color: white;
  padding: 20px;
  line-height: 1.6;
  max-width: 800px;
  margin: auto;
}

.legal-mentions h1 {
  text-align: center;
  font-size: 28px;
  color: darkgrey;
  margin-bottom: 20px;
}

.legal-mentions h2 {
  font-size: 20px;
  color: grey;
  margin-top: 20px;
  margin-bottom: 10px;
}

.legal-mentions p {
  font-size: 16px;
}

.legal-mentions a {
  color: black;
  text-decoration: none;
}

.legal-mentions a:hover {
  text-decoration: underline;
}
</style>
